/* QOWAA FIT — Page FAQ : accordéons Q/R + chips d'ancrage (smooth scroll) + reveal. */
(function () {
  'use strict';
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function initFaq(root) {
    // Accordéons (toggle indépendant)
    $all('.faq-item__q', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var panel = item.querySelector('.faq-item__a');
        if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      });
    });

    // Chips → smooth scroll vers la section + ouvre la 1ʳᵉ question si fermée
    $all('[data-faq-chip]', root).forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        var id = chip.getAttribute('href').replace('#', '');
        var sec = document.getElementById(id);
        if (!sec) return;
        sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // Reveal
    var revs = $all('.scroll-in', root);
    if (revs.length) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) { revs.forEach(function (e) { e.classList.add('is-in'); }); }
      else { var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.12 }); revs.forEach(function (e) { io.observe(e); }); }
    }
  }

  function boot() { $all('[data-qw-faq]').forEach(initFaq); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-qw-faq]'); if (r) initFaq(r); });
})();
